import { useEffect, useState } from "react";
import axios from "axios";
import { queryParams } from "../../../../utils/queryParams";
import { PAGES_EXCLUDE_SELECTOR, UPDATE_STATUS } from "../constants";

const getUrlParams = () => {
  const url = window.location.href;
  const { searchParams } = new URL(url);

  return {
    short_url: searchParams.get("short_url") || searchParams.get("dashboard_short_url"),
    client_uid: searchParams.get("client_uid"),
    url
  };
};

export const useHeaderProps = () => {
  const [data, setData] = useState(null);

  const { short_url, client_uid, url } = getUrlParams();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`${queryParams.apiVersion}settings/user_props`, {
          params: {
            short_url
          }
        });
        setData(res.data);
      } catch (err) {
        console.error(err.message);
      }
    };

    fetchData();
  }, []);

  return (
    data && {
      ...data,
      showLocationSelector:
        !PAGES_EXCLUDE_SELECTOR.some((page) => url.includes(page)) && !client_uid,
      lastUpdateClass: data?.last_data_update_info === UPDATE_STATUS.IN_PROGRESS ? "inProgress" : ""
    }
  );
};
